var exports = {
  "P": "bannerList__-XRI-D",
};

module.exports = exports;
